export { default as default } from './ModalComponent.jsx';